export function notSpaceBar(value: string){
  const finalStr = `${value}`;

  return finalStr.replace(/\s/g, '');
}

export default notSpaceBar;
